import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75693b35")

_pushScopeId("data-v-75693b35")
const _hoisted_1 = { class: "answer-container" }
const _hoisted_2 = { class: "rank-history-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "left-wrapper" }, [
  /*#__PURE__*/_createVNode("span", null, "当前排名")
], -1)
const _hoisted_4 = { class: "right-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "left-wrapper" }, [
  /*#__PURE__*/_createVNode("span", null, "历史最高")
], -1)
const _hoisted_6 = { class: "right-wrapper" }
const _hoisted_7 = { class: "cover-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Back = _resolveComponent("Back")
  const _component_Title = _resolveComponent("Title")
  const _component_Action = _resolveComponent("Action")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _createVNode(_component_Title, {
          img: `${_ctx.rootUrl}/answer/daily_title.png`
        }, null, 8, ["img"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "rank-history-item",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goRank && _ctx.goRank(...args)), ["stop","prevent"]))
          }, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode("span", null, _toDisplayString(_ctx.rank), 1)
            ])
          ]),
          _createVNode("div", {
            class: "rank-history-item",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goRecord && _ctx.goRecord(...args)), ["stop","prevent"]))
          }, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("span", null, _toDisplayString(_ctx.grade), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("img", {
            src: `${_ctx.rootUrl}/answer/daily_cover.png`
          }, null, 8, ["src"])
        ]),
        _createVNode(_component_Action, {
          text: _ctx.isActionActive ? _ctx.actionTitleActive : _ctx.actionTitleDisable,
          isActive: _ctx.isActionActive,
          onAction: _ctx.doAnswer
        }, null, 8, ["text", "isActive", "onAction"])
      ])
    ]),
    _: 1
  }))
})